import React from 'react';
import { FormField, inputClass } from './FormField';

const IMMIGRATION_STATUSES = [
  { value: '', label: 'Select status...' },
  { value: 'citizen', label: 'U.S. Citizen' },
  { value: 'lpr', label: 'Lawful Permanent Resident (LPR / Green Card)' },
  { value: 'daca', label: 'DACA Recipient' },
  { value: 'visa_holder', label: 'Visa Holder' },
  { value: 'undocumented', label: 'Undocumented' },
];

export const StepParentInfo = ({ formData, onChange, errors }) => {
  const set = (field) => (e) => onChange({ ...formData, [field]: e.target.value });

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-lg font-semibold text-brand-navy mb-1">Parent / Grantor Information</h3>
        <p className="text-sm text-slate-500">Provide the legal details of the person granting this power of attorney.</p>
      </div>

      <FormField label="Full Legal Name" error={errors.parentFullName} required>
        <input
          type="text"
          className={inputClass(errors.parentFullName)}
          value={formData.parentFullName || ''}
          onChange={set('parentFullName')}
          placeholder="As it appears on government ID"
        />
      </FormField>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <FormField label="Date of Birth" error={errors.parentDOB} required>
          <input
            type="date"
            className={inputClass(errors.parentDOB)}
            value={formData.parentDOB || ''}
            onChange={set('parentDOB')}
          />
        </FormField>

        <FormField label="Country of Origin" error={errors.parentCountry} required>
          <input
            type="text"
            className={inputClass(errors.parentCountry)}
            value={formData.parentCountry || ''}
            onChange={set('parentCountry')}
            placeholder="e.g. Mexico, Guatemala"
          />
        </FormField>
      </div>

      <FormField label="Immigration Status" error={errors.parentImmigrationStatus} required>
        <select
          className={inputClass(errors.parentImmigrationStatus)}
          value={formData.parentImmigrationStatus || ''}
          onChange={set('parentImmigrationStatus')}
        >
          {IMMIGRATION_STATUSES.map((s) => (
            <option key={s.value} value={s.value}>{s.label}</option>
          ))}
        </select>
      </FormField>

      <FormField label="Current Address" error={errors.parentAddress} required>
        <textarea
          className={`${inputClass(errors.parentAddress)} min-h-[80px] resize-none`}
          value={formData.parentAddress || ''}
          onChange={set('parentAddress')}
          placeholder="Street address, city, state, ZIP code"
        />
      </FormField>
    </div>
  );
};